import DataTableView from "@components/views/datatable-view";
import DateRangePicker from "@components/fields/date-picker/range-picker";
import Filter from "./misc/filter";
import Flex from "@src/@core/components/ui-components/flex";
import { FormProvider } from "react-hook-form";
import { LAST_7_DAYS_DATE } from "@src/utility/constants";
import SideFilter from "@components/ui-components/side-filter";
import useDateHandler from "@src/utility/hooks/use-date-handler";
import useOnboardingWon from "./use-onboarding-won";
import useDataTableSort from "@src/utility/hooks/use-data-table-sort";

const Reports = () => {
    const {
        data: { reports = [], total },
        loading,
        columns,
        getReport,
        onSubmit,
        onReset,
        methods
    } = useOnboardingWon();

    const {
        sortField,
        sortDirection,
        handleSort
    } = useDataTableSort();
    
    const { control, handleDateChange } = useDateHandler({
        onSubmit       : getReport,
        defaultHandling: true,
        defaultValues  : LAST_7_DAYS_DATE
    });

    return (
        <DataTableView
            moduleName={"Reports"}
            breadcrumbItems={{
                items: [
                    {
                        title : "Reports",
                        active: true
                    }
                ],
                rightChildren: (
                    <DateRangePicker
                        control={control}
                        customOnChange={handleDateChange}
                        maxDate={new Date()}
                        id="date"
                        name="date"/>
                )
            }}
            loading={loading}
            localPagination
            tableProps={{
                data  : reports,
                columns,
                footer: columns?.reduce((acc, { id }, idx) => {
                    acc[id] = id === "mrr" ? total : idx === 0 ? "Total" : "-";
                    return acc;
                }, {}),
                sortField,
                sortDirection,
                handleSort
            }}
          
            actionItems={
                <Flex align="center">
                    <SideFilter 
                        title="Filters" 
                        onSubmit={() => onSubmit()}
                        onReset={() => onReset()}>
                        <FormProvider {...methods}>
                            <Filter />
                        </FormProvider>
                    </SideFilter>
                </Flex>
            }/>
    );
};

export default Reports;